/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".media-title[_ngcontent-%COMP%]{font-family:Open Sans;font-size:12px;color:#8e8fa6}.media-filter-buttons[_ngcontent-%COMP%]{display:flex;justify-content:center}.media-filter-button[_ngcontent-%COMP%]{margin:0 3px;padding:0 10px 1px;font-family:Open Sans;font-size:14px;text-align:center}.nz-card[_ngcontent-%COMP%]{padding:20px 20px 5px}"];
export { styles as styles };
